import { navStepAtom, userInfoAtom } from "src/atoms";
import SiteTrialUI from "./SiteTrial.presenter";
import { useRecoilState } from "recoil";
import { useEffect, useState } from "react";
import { getLanguage } from "src/utils/localization";
import { useRouter } from "src/hooks/useRouter";
import { maxLengthValidation } from "src/utils/validation";
import { useModal } from "src/hooks/useModal";
import { checkPromotionTrial, createServiceTrial } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useTranslation } from "react-i18next";
import { ProductKey } from "src/config/config";

interface ISiteTrialContainerProps { }
const SiteTrialContainer = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const { openTermsService, openPrivacyPolicy } = useModal();
  const [confirmPolicy, setConfirmPolicy] = useState<boolean>(false);
  const [priceType, setPriceType] = useState<string>("");
  const [payTerm, setPayTerm] = useState<string>("year");
  const [isCheckTrial, setIsCheckTrial] = useState<boolean>(false);
  const [purpose, setPurpose] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>(userInfo?.companyName);
  const [telNumber, setTelNumber] = useState<string>("");
  const [userName, setUserName] = useState<string>(userInfo?.userName);
  const [usernameNoti, setUserNameNoti] = useState<string>("");
  const [contactInfoNoti, setContactInfoNoti] = useState<string>("");
  const [companyNoti, setCompanyNoti] = useState<string>("");
  const [purposeNoti, setPurposeNoti] = useState<string>("");
  const [product, setProduct] = useState<string>(
    getProductFromSessionStorage()
  );
  const [type, setType] = useState<string>("");
  const [code, setCode] = useState<string>("");
  const [showType, setShowType] = useState<string>("POSSIBLE");
  const [promotionCode, setPromotionCode] = useState<string>("");
  const route = useRouter();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const lang = getLanguage();
    if (e.target.name === "confirmPolicy") {
      setConfirmPolicy((prev) => !prev);
    } else if (e.target.name === "siteType") {
      setPriceType(e.target.value);
      if (e.target.value === "trial") {
        route.goSiteTrial();
      } else if (e.target.value === "promotion") {
        route.goSitePromotion({});
      } else if (e.target.value !== priceType) {
        route.goPay({ pay: payTerm, type: e.target.value });
      }
    } else if (e.target.name === "purpose") {
      setPurpose(e.target.value);
    } else if (e.target.name === "companyName") {
      setCompanyName(e.target.value);
    } else if (e.target.name === "telNumber") {
      setTelNumber(e.target.value);
    } else if (e.target.name === "userName") {
      setUserName(e.target.value);
    }
  };

  const tiralApply = async () => {
    try {
      const userNameLength = maxLengthValidation(userName, 50);
      const telNumberLength = maxLengthValidation(telNumber, 30);
      const companyNameLength = maxLengthValidation(companyName, 100);
      const purposeLength = maxLengthValidation(purpose, 500);

      if (
        !userNameLength ||
        !telNumberLength ||
        !companyNameLength ||
        !purposeLength
      ) {
        if (!userNameLength) {
          setUserNameNoti(t("siteType.free.detail.alertMsg1"));
        } else {
          setUserNameNoti("");
        }

        if (!telNumberLength) {
          setContactInfoNoti(t("siteType.free.detail.alertMsg2"));
        } else {
          setContactInfoNoti("");
        }

        if (!companyNameLength) {
          setCompanyNoti(t("siteType.free.detail.alertMsg3"));
        } else {
          setCompanyNoti("");
        }

        if (!purposeLength) {
          setPurposeNoti(t("siteType.free.detail.alertMsg4"));
        } else {
          setPurposeNoti("");
        }
        return;
      }

      const result = await createServiceTrial({
        userName,
        telNumber,
        companyName,
        purpose,
        product,
      });
      if (result) {
        route.goConsole();
      }
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        alert(error.errorMessage);
      }
    }
  };
  useEffect(() => {
    if (
      confirmPolicy &&
      purpose !== "" &&
      companyName !== "" &&
      telNumber !== "" &&
      userName !== ""
    ) {
      setIsCheckTrial(true);
    } else {
      setIsCheckTrial(false);
    }
  }, [confirmPolicy]);
  useEffect(() => {
    async function init() {
      const lang = getLanguage();
      setNavStep(2);
      // await getMySiteStatus()

      window.sessionStorage.removeItem("payType");
      // if (!this.commonStore.confirmTrial) {
      // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`

      // }

      try {
        const result = await checkPromotionTrial({
          product: sessionStorage.getItem("product") as ProductKey,
        });
        console.log("test", result);
        if (result) {
          const showType = result.status;
          const promotionCode = result.promotionCode;
          // const userName = userInfo.userName

          setShowType(showType);
          setPromotionCode(promotionCode);
          // setUserName(userName)

          if (result.promotionCode !== null) {
            setNavStep(3);
          }
          if (showType !== "POSSIBLE") {
            //    window.location.href = `${process.env.PUBLIC_URL}/console`
            route.goConsole();
          }
        }
      } catch (error: any) {
        if (error?.errorCode && error?.errorMessage) {
          alert(error.errorMessage);
          route.goConsole();
        }
      }
    }
    init();
  }, []);
  return (
    <SiteTrialUI
      userName={userInfo.userName}
      telNumber={telNumber}
      companyName={companyName}
      purpose={purpose}
      confirmPolicy={confirmPolicy}
      handleChange={handleChange}
      isCheckTrial={isCheckTrial}
      tiralApply={tiralApply}
      showType={showType}
      goBack={route.goConsole}
      makeSite={() => { }}
      openTermsService={openTermsService}
      openPrivacyPolicy={openPrivacyPolicy}
      // openPaidTermsService={openPaidTermsService}
      usernameNoti={usernameNoti}
      contactInfoNoti={contactInfoNoti}
      companyNoti={companyNoti}
      purposeNoti={purposeNoti}
    // showSiteNewModal={showSiteNewModal}
    // hideModal={hideModal}
    // type={type}
    // code={code}
    // showPolicy={showPolicy}
    // tabTarget={tabTarget}
    />
  );
};

export default SiteTrialContainer;
